import PageUtils from '../modules/page-utils';
import Swiper from '../modules/swiper';
import Modal from '../modules/modal';
import HalfBgRow from '../modules/half-bg-row';
import Lightbox from '../modules/lightbox';
import Video from '../modules/video';
import StoreLocator from '../modules/store-locator';
import Search from '../modules/search';
import ArchiveTables from '../modules/archive-tables';
import Timeline from '../modules/timeline';
import LangSwitcher from '../modules/lang-switcher';
import SliderHomeAnimations from '../modules/slider-home-animations';
// import MediaContentBlockAnimations from "../modules/media-content-block-animations";
import VerticalsliderTitlesAnimations from '../modules/verticalslider-titles-animations';
import Chatbot from '../modules/chatbot';

export default {
  init() {
    // JavaScript to be fired on all pages

    // add defer to lottie script
    const lottieScript = document.querySelector('script[src*="lottie"]');
    lottieScript && lottieScript.setAttribute('defer', '');

    //add defer to select2 script
    const select2Script = document.querySelector('script[src*="select2"]');
    select2Script && select2Script.setAttribute('defer', '');
  },
  finalize() {
    // Set Utilities
    PageUtils();
    SliderHomeAnimations();
    Swiper();
    Modal();
    HalfBgRow();
    Lightbox();
    Video();
    StoreLocator();
    Search();
    ArchiveTables();
    Timeline();
    LangSwitcher();
    // MediaContentBlockAnimations();
    VerticalsliderTitlesAnimations();
    Chatbot();

    // Navigation is wired up early from app.js, not here.
  }, //fine finalized
};
